import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatTable, MatTableDataSource, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { IService } from '../../../model/common.model';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatError, MatFormField } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { EcaFormColumnModule } from '@drc-eca/eca-components-lib';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-add-update-client-modal',
    standalone: true,
    templateUrl: './add-update-client-modal.component.html',
    styleUrls: ['./add-update-client-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
      MatFormFieldModule,
      MatInputModule,
      MatTable,
      MatColumnDef,
      MatHeaderCellDef,
      MatHeaderCell,
      MatCellDef,
      MatCell,
      MatHeaderRowDef,
      MatHeaderRow,
      MatRowDef,
      MatRow,
      MatDialogModule,
      MatSelectModule,
      MatError,
      MatIcon,
      MatCheckbox,
      EcaFormColumnModule,
      MatFormField,
      ReactiveFormsModule,
      FormsModule,
      MatButtonModule
    ]  
})
export class AddUpdateClientModalComponent {
  dialogRef = inject<MatDialogRef<AddUpdateClientModalComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);


  form: UntypedFormGroup = new UntypedFormGroup({
    code: new UntypedFormControl(null, Validators.required),
    title: new UntypedFormControl(null, Validators.required),
    description: new UntypedFormControl(null, Validators.required)
  });
  action = 'Add';
  serviceList: { checked: boolean; name: string; alias: string; primaryKeyPart: string }[] = [];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  displayedColumns: string[] = ['checked', 'name', 'alias'];

  constructor() {
    const data = this.data;

    let associatedServices = {};
    if (data.selectedClient) {
      associatedServices = data.selectedClient.services || {};
      ['code', 'title', 'description'].forEach(key => {
        this.form.controls[key].setValue(data.selectedClient[key]);
      });
      this.action = 'Update';
      this.form.controls['code'].disable();
    }

    this.serviceList = (data.serviceList || []).map((service: IService) => {
      return {
        checked: Object.keys(associatedServices).indexOf(service.primaryKeyPart) > -1,
        name: service.name,
        alias: associatedServices[service.primaryKeyPart],
        primaryKeyPart: service.primaryKeyPart
      }
    });

    this.dataSource.data = this.serviceList;
  }


}
